import { HttpClient } from '../httpClient';
import UsersResponse from '../responses/usersResponse';
import UserResponse from '../responses/userResponse';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import UserRequest from '../requests/userRequest';

const httpClient = new HttpClient();

export const getUsers = async (
  firstName: string,
  lastName: string,
  email: string
) => {
  return httpClient.get<UsersResponse>({
    url: `/v1/admin/users/?firstName=${firstName}&lastName=${lastName}&email=${email}`,
    requiresToken: true,
  });
};

export const getAllUsers = async () => {
  return httpClient.get<UsersResponse>({
    url: `/v1/admin/users/`,
    requiresToken: true,
  });
};

export const getUser = async (userId: number) => {
  return httpClient.get<UserResponse>({
    url: `/v1/admin/users/${userId}`,
    requiresToken: true,
  });
};

export const createUser = async (userRequest: UserRequest) => {
  return httpClient.post<DataResponse<number>>({
    url: '/v1/admin/users',
    payload: userRequest,
    requiresToken: true,
  });
};

export const updateUser = async (userId: number, userRequest: UserRequest) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/users/${userId}`,
    payload: userRequest,
    requiresToken: true,
  });
};

export const deleteUser = async (userId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/users/${userId}`,
    requiresToken: true,
  });
};

export const getRecipients = async (excludeMe: boolean) => {
  return httpClient.get<UsersResponse>({
    url: `/v1/users/?excludeMe=${excludeMe}`,
    requiresToken: true,
  });
};
